export default __webpack_public_path__ + "static/media/Frame5.07a85192.png";